import React from 'react'
import { CCol, CForm, CRow, CFormCheck, CFormSelect, CLoadingButton } from '@coreui/react-pro'
import { useFormik } from 'formik'
import CommonService from 'src/service/CommonService'
import ToastComponent from 'src/components/common/TaostComponent'

const OverseasLimit = (props) => {
  const formik = useFormik({
    initialValues: {
      external_player_limit: props.gameData?.external_player_limit || 1,
      external_player_tag: Number(props.gameData?.external_player_tag) || 0,
    },
    enableReinitialize: true,
    onSubmit: (data) => {
      data.external_player_limit_status = props.showOverseasStatus

      CommonService.updateOverseasLimit(data).then((res) => {
        if (res.status === 200) {
          ToastComponent(res.message, 'success')
        }
      })
    },
  })
  const teamSize = props.gameData?.team_size || 1

  const teamSizeLimitValues = Array.from({ length: teamSize }, (v, k) => k + 1)

  const handleOverseasStatusChange = (event) => {
    const value = event.target.id === 'overseas-default' ? 0 : 1
    props.setShowOverseasStatus(value)
  }

  return (
    <>
      <CRow>
        <CCol md={12}>
          <CForm className="row g-3" onSubmit={formik.handleSubmit}>
            <div>
              {/* DEFAULT SETTING */}
              <CFormCheck
                button={{ color: 'success', variant: 'outline' }}
                type="radio"
                name="overseas-setting"
                id="overseas-default"
                autoComplete="off"
                label="Default (Disabled)"
                checked={props.showOverseasStatus == 0}
                onChange={handleOverseasStatusChange}
              />
              &nbsp;
              {/* CUSTOM SETTING */}
              <CFormCheck
                button={{ color: 'danger', variant: 'outline' }}
                type="radio"
                name="overseas-setting"
                id="overseas-custom"
                autoComplete="off"
                label="Custom Setting"
                checked={props.showOverseasStatus == 1}
                onChange={handleOverseasStatusChange}
              />
              {props.showOverseasStatus === 1 && (
                <CRow>
                  {/* MAX EXTERNAL PLAYERS */}

                  <CCol md={6} xs={6} className="pt-3">
                    <label className="fw-bold">
                      Maximum PCR tagged players a member is allowed to pick in the team?
                    </label>

                    <CFormSelect
                      name="external_player_limit"
                      id="external_player_limit"
                      className="mt-3"
                      value={formik.values.external_player_limit}
                      onChange={formik.handleChange}
                      disabled={props.isTeamExists}
                    >
                      {teamSizeLimitValues.map((number) => (
                        <option key={number} value={number}>
                          {number}
                        </option>
                      ))}
                    </CFormSelect>
                  </CCol>

                  {/* TAG NAME */}

                  <CCol md={6} xs={6} className="pt-3">
                    <label className="fw-bold">Term used in the game?</label>

                    <CFormSelect
                      name="external_player_tag"
                      id="external_player_tag"
                      className="mt-3"
                      value={formik.values.external_player_tag}
                      onChange={(e) =>
                        formik.setFieldValue('external_player_tag', Number(e.target.value))
                      }
                    >
                      {props.exeternalPlayerList?.map((item) => (
                        <option key={item.id} value={item.id}>
                          {item.name}
                        </option>
                      ))}
                    </CFormSelect>
                  </CCol>
                </CRow>
              )}
            </div>

            <CCol md={6}>
              <CLoadingButton type="submit" color="success" variant="outline">
                Submit
              </CLoadingButton>
            </CCol>
          </CForm>
        </CCol>
      </CRow>
    </>
  )
}

export default OverseasLimit
